<!-- 羿畅责任 -->
<template>
    <div class="obligation">
        <section>
            <div class="title">客户责任</div>
            <article class="customer">
                <div class="item">
                    <div class="describe" style=" padding: 40px 40px 0 0;">
                        <div class="label">坚持自主创新</div>
                        <p class="text">
                            羿畅坚持自主创新，核心研发聚焦于养护业务和科学决策分析核心模型研究，
                            对多源数据资源进行整合与硬件集成等方式，通过大数据融合，机器学习、深
                            度算法、分布式、PaaS专用云和行业SaaS。与武汉大学、理工大学、地质大
                            学均设有联合研发中心。
                        </p>
                    </div>
                    <div class="image">
                        <img src="@/assets/image/obligationYC/khzr_1.png" style="height: 100%;width: 100%;" alt="">
                    </div>
                </div>
                <div class="item">
                    <div class="image">
                        <img src="@/assets/image/obligationYC/khzr_2.png" style="height: 100%;width: 100%;" alt="">
                    </div>

                    <div class="describe" style=" padding: 40px  0 0 40px;">
                        <div class="label">追求优质服务</div>
                        <div class="text">
                            羿畅服务遍布21个省份，218个县区，在示范县创建技术服务中，派驻两名专职工
                            程师全程驻场服务，直至创建资料全部完成，并能做到精准估算。智慧交通平台建
                            设从初期的精细化调研-产品设计-PRD宣讲-优化设计-代码编写-稳定性测试-试运行-
                            正式交付全流程专业团队跟踪服务，始终以客户需求为中心，打造用户实用、好
                            用、易用的产品，为客户管理工作带来便捷。专业的售后运维服务团队，定期拜访跟
                            进使用情况，遇到问题12小时内及时处理，24小时内抵达现场支撑。
                        </div>
                    </div>
                </div>

            </article>
        </section>
        <section class="social-bg">
            <div class="title">社会责任</div>
            <article class="social">
                <div
                    class="item"
                    v-for="(item,index) in socialList"
                    :key="index"
                    :style="{backgroundImage: `url(${item.bg})`}"
                >
                    <div class="mark">
                        <div class="label">{{ item.label }}</div>
                        <div class="text">{{ item.text }}</div>
                    </div>
                </div>
            </article>
        </section>
        <section>
            <div class="title">员工责任</div>
            <article class="employee">
                <div class="item" v-for="(item,index) in employeeList" :key="index">
                    <img :src="item.image" alt="" class="image">
                    <div class="info">
                        <div class="label">{{ item.label }}</div>
                        <div class="text">{{ item.text }}</div>
                    </div>

                </div>
            </article>
        </section>
    </div>
</template>

<script>
export default {
    name: 'obligationYC',
    data() {
        return {
            socialList: [
                {
                    label: '提升交通运行效率',
                    text: `通过对公路建管养运四个方面全方位打造，实现人、车、路、物、事、云之间数据互通，
                    使道路交通系统具备感知、互联、分析、预测、控制等能力，提升交通运行效率，共建美好出行。`,
                    bg: require('@/assets/image/obligationYC/shzr_card1.png'),
                },
                {
                    label: '赋能乡村振兴发展',
                    text: `通过交通信息化管理，形成“基础数据精准、交通设施优良、建设项目可控、管理规范有效、
                    养护科学决策、运输服务优质、安全监管有力”的农村公路交通运输体系，实现农村公路工作调度一体
                    化、数据应用一个库、过程监管一条线、 建管养运一盘棋的新时代数字化管理目标，发挥农村公路对
                    乡村振兴的服务保障和先行引领作用，增强人民群众获得感、幸福感、安全感，促进了公路事业高质量
                    发展。`,
                    bg: require('@/assets/image/obligationYC/shzr_card2.png'),
                },
                {
                    label: '促进群众便捷出行',
                    text: `通过整合综合车辆数据资源，以车辆监管一张图为基础，对出租车、城乡公交、货运车、危化
                    品车等重点车辆即时感知、智能监管、分析研判和协同处置；实现从车辆登记到车辆运输和违法处置的
                    全过程、人车企信息全覆盖，构建数据全闭环、管理全流程的监管体系。发挥营运车辆位置数据价值，开
                    发APP或公众服务号对公众提供实时班线、公交客运等车辆位置查询、到站距离、换乘方式，预计到达时
                    间等信息的发布和查询服务，实现“人便于行”“货畅其流”，有效提高城乡公路交通公共服务均等化水平。`,
                    bg: require('@/assets/image/obligationYC/shzr_card3.png'),
                }
            ],
            employeeList: [
                {
                    label: '关注员工发展',
                    text: `建立了完善的双通道职业发展路线，贯穿全部职级的培训制度，
                    包括新人培训计划、指导教练计划、员工成长计划、胜任力培养计划；
                    专门罗列年度预算鼓励并支持MBA、EMBA、项目管理等中高级人才培
                    训及外派学习交流。`,
                    image: require('@/assets/image/obligationYC/ygzr_card1.png')
                },
                {
                    label: '保障员工健康',
                    text: `提供舒适健康的办公环境，新员工入职体检以及年度定期健康体检；
                    额外的商业保险及重大疾病报销。`,
                    image: require('@/assets/image/obligationYC/ygzr_card2.png')
                },
                {
                    label: '温暖员工',
                    text: `提供各类的节假日福利，同时关爱员工的家人，提供专门保险、节日礼物，
                    提供直系亲属的重大疾病报销；丰富多彩的公司内部及外部团建活动。`,
                    image: require('@/assets/image/obligationYC/ygzr_card3.png')
                }
            ]
        }
    },
    //刷新或通过URL地址进入页面时，同步背景图和标题
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$nextTick(() => {
                vm.$bus.$emit('changePageTitleAndBackground', {page: 'obligationYC'})
            })
        })
    },
    methods: {},
}
</script>

<style lang='scss' scoped>
.obligation {
    height: 100%;
    width: 100%;

    section {
        margin: 0 auto;

        padding-top: 100px;

        .title {
            font-size: 36px;
            text-align: center;
        }

        article {
            margin: 80px auto 0 auto;
            width: 1200px;
        }
    }

    .customer {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: repeat(2, 1fr);

        .item {
            display: flex;

            .describe {
                width: calc(100% - 600px);
                box-sizing: border-box;
                color: #333333;

                .label {
                    font-size: 24px;
                    font-weight: bold;
                }

                .text {
                    margin-top: 20px;
                    font-size: 20px;
                    line-height: 30px;
                    text-align: justify;
                }

            }

            .image {
                width: 600px;
                height: 324px;
            }
        }


    }

    .social-bg {
        background-image: url("~@/assets/image/obligationYC/shzr_bg.png");
        background-repeat: no-repeat;
        background-size: 100% 360px;
        background-position: 100% 80%;
    }

    .social {

        display: flex;

        .item {
            flex: 1;
            height: 500px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            color: #FFFFFF;


            .mark {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                padding: 70px 50px;
            }

            .label {
                font-size: 30px;
                text-align: center;
            }

            .text {
                font-size: 14px;
                margin-top: 40px;
                text-align: justify;
                line-height: 32px;
            }
        }
    }

    .employee {
        display: flex;
        justify-content: space-between;
        padding-bottom: 100px;

        .item {
            width: calc(100% / 3 - 32px);

            .image {
                width: 100%;
                height: 420px;
            }

            .label {
                margin-top: 50px;
                font-size: 24px;
                color: #333333;
                text-align: center;
                font-weight: bold;
            }

            .text {
                margin-top: 30px;
                font-size: 20px;
                line-height: 30px;
                text-align: justify;
            }
        }
    }
}

@import "./style.scss";
</style>
